import React, { useEffect, useState } from "react";
import { IP } from "../../../../internalServer";
import { iconData } from "../../../../iconData";
import { Player } from "video-react";
import PdfViewer from "../../../../HwManagement/PdfViewer/PdfViewer";

export default function SubmisshionByUpload({ questionNo, response }) {
  const [responseAttach, setResponseAttach] = useState();
  const [isError, setIsError] = useState(false);
  const [pedingSubDetail, setPedingSubDetail] = useState({
    pdfView: false,
  });
  const handleRemovePdfVivwer = () => {
    setPedingSubDetail({
      ...pedingSubDetail,
      pdfView: false,
    });
  };

  const [isClicked, setIsClicked] = useState(false);
  const [answerLimit, setAnswerLimit] = useState(
    response?.question?.type?.maxLimit ? response?.question?.type?.maxLimit : 2500
  );
  useEffect(() => {
    setAnswerLimit(response?.question?.type?.maxLimit);
  }, [response?.question?.type]);

  const handleClick = (attachment) => {
    setResponseAttach(attachment);
    setIsClicked(!isClicked);
  };

  return (
    <>
      <div className="containerBelowQuestion">
        <div className="d-flex justify-content-between">
          <div className="Question">
            Q{questionNo}. {response?.question?.title?.split("\n").map((line, index) => (
              <React.Fragment key={index}>
                {index !== 0 && <br />}
                <span style={index !== 0 ? { marginLeft: "30px", display: "inline-block" } : {}}>
                  {line}
                </span>
              </React.Fragment>
            ))}
            {response?.question?.is_mandatory && (
              <span style={{ marginLeft: "20px", color: "#AC1616", fontSize: "10px", fontWeight: "700" }}>
                *Mandatory
              </span>
            )}
          </div>
        </div>

        {response?.question?.attachments?.length > 0 &&
          response.question.attachments.map((attachment, index) => {
            const fileExt = attachment?.split(".").pop()?.toLowerCase();
            const isImage = ["jpg", "jpeg", "png"].includes(fileExt);
            const isVideo = fileExt === "mp4";

            const fileName = attachment?.replace(/^[^_]*_/, "") || "";
            const shortName =
              fileName.length > 15
                ? fileName.substring(0, 15) + "..."
                : fileName;

            const icon =
              iconData?.find(
                (i) => i.extension.toLowerCase() === fileExt
              )?.icon || "/images/file.svg";

            const fullUrl = IP + attachment?.replace(/^\./, "");

            return (
              <div key={index} className="mt-2">

                {isImage && (
                  <img
                    src={fullUrl}
                    alt="Attachment"
                    className="mt-3 imageWidthAndHeight"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      if (!isError) handleClick(attachment);
                    }}
                  />
                )}

                {isVideo && (
                  <div
                    className="d-flex pdfContainer gap-2 p-2"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      if (!isError) handleClick(attachment);
                    }}
                  >
                    <div className="d-flex align-items-center">
                      <img className="extention_icon" src={icon} alt="video" />
                    </div>

                    <div className="w-100">
                      <div className="pdfName" title={fileName}>
                        {shortName}
                      </div>
                      <div className="pdfFileSize">12 KB</div>
                    </div>
                  </div>
                )}

                {!isImage && !isVideo && (
                  <div
                    className="d-flex pdfContainer gap-2 p-2"
                    style={{ cursor: "pointer" }}
                    onClick={() =>
                      setPedingSubDetail({
                        ...pedingSubDetail,
                        pdfView: true,
                        attachment: attachment,
                      })
                    }
                  >
                    <div className="d-flex align-items-center">
                      <img className="extention_icon" src={icon} alt={fileExt} />
                    </div>

                    <div className="w-100">
                      <div className="pdfName" title={fileName}>
                        {shortName}
                      </div>
                      <div className="pdfFileSize">12 KB</div>
                    </div>
                  </div>
                )}
              </div>
            );
          })}


        <div className="yourAnswerTextArea mt-3">Your answer</div>
        <div>
          {response?.description ? (
            <div style={{ position: "relative" }} className="mt-3 mb-3">
              <textarea
                placeholder="Type to write your answer here."
                className="textInputQuestion p-3"
                maxLength={answerLimit}
                readOnly
                value={response?.description}
              ></textarea>
              <div
                className="maxWordCount"
                style={{
                  position: "absolute",
                  bottom: "10px",
                  right: "10px",
                }}
              >
                {response?.description?.length}/{answerLimit}
              </div>
            </div>
          ) : (
            <div>{!response?.description && <span>No Answers</span>}</div>
          )}
        </div>
      </div>
      {pedingSubDetail.pdfView && (
        <PdfViewer
          handleRemovePdfVivwer={handleRemovePdfVivwer}
          attachment={pedingSubDetail?.attachment}
        />
      )}
      {isClicked &&
        (responseAttach.split(".").pop() === "mp4" || responseAttach.split(".").pop() === "MP4" ? (
          <div className="fullSizeImg ">
            <div className="SubfullSizeImg">
              <video className="videoPlayer" controls>
                <source src={IP + responseAttach.replace(/^\./, "")} type="video/mp4" />
              </video>
              <div>
                <img
                  className="crossIconImgQue"
                  onClick={handleClick}
                  src="/DCM-img/crossIcon.svg"
                  alt="Up Arrow"
                />
              </div>
            </div>
          </div>
        ) : (
          <div className="fullSizeImg ">
            <div className="SubfullSizeImg">
              {
                !isError ? (
                  <>
                    <img
                      className="imgMain"
                      src={IP + responseAttach?.replace(/^\./, "")}
                      alt="Full-size"
                      onError={(e) => {
                        setIsError(true)
                      }}
                    />
                    <div>
                      <img
                        className="crossIconImgQue"
                        onClick={handleClick}
                        src="/images/cross.png"
                        alt="Up Arrow"
                      />
                    </div>
                  </>
                ) : (
                  <div className="fullSizeImg" style={{ display: "flex", flexDirection: "column" }}>
                    <img
                      onClick={() => {
                        setIsError(false)
                        handleClick()
                      }}
                      src="/images/cross.png"
                      alt="Up Arrow"
                      style={{ position: "absolute", top: "75px", right: "40%" }}
                    />
                    <img src="/images/no-photo1.png" alt="img" style={{ width: "25%" }} />
                    <p style={{ color: "red", fontSize: "20px", fontWeight: "500", marginRight: "35px" }}>Error!! failed to load the requested file!</p>
                  </div>
                )
              }
            </div>
          </div>
        ))}
    </>
  );
}
